<!--分页查询美育浸润-->
<template>
    <div class="myjr-studio_nav_content">
        <div class="page-mode" v-show="showMode==='pageSub'">
            <div class="my-info-container">
                <div class="info-l-container">
                    <div :class="activeItem===1?'class-item-active mt20':'class-item mt20'" @click="changeActiveItem(1)">音乐</div>
                    <div :class="activeItem===2?'class-item-active mt20':'class-item mt20'" @click="changeActiveItem(2)">美术</div>
                    <div :class="activeItem===3?'class-item-active mt20':'class-item mt20'" @click="changeActiveItem(3)">主题班会</div>
                </div>
                <div class="info-r-container" v-if="activeItem===1">
                    <div class="head-container">
                        <div class="left-head-container" @click="backList">
                            <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                        </div>
                        <div class="right-head-container">{{ this.classTitle }}</div>
                        <div class="left-head-container">
                        </div>
                    </div>
                    <!--搜索-->
                    <el-row class="mt0" style="padding:0 10px 0 10px;box-sizing: border-box">
                        <el-col :span="5" class="mb0">
                            <el-form-item label="学段">
                                <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择学科">
                                    <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1" class="mb0"></el-col>
                        <el-col :span="5" class="mb0">
                            <el-form-item label="年级">
                                <el-select clearable @change="pageList(null)" v-model="queryParams.gradeKey" placeholder="请选择年级">
                                    <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1" class="mb0"></el-col>
                        <el-col :span="5" class="mb0">
                            <el-form-item label="年级段">
                                <el-select clearable @change="pageList(null)" v-model="queryParams.myjrGrade" placeholder="请选择年级段">
                                    <el-option v-for="item in myjrGradeList" :key="item.dictKey" :label="item.dictValue"
                                               :value="item.dictKey" />
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="1" class="mb0"></el-col>
                        <el-col :span="6" class="mr0 mb0">
                            <el-form-item class="pull-right">
                                <el-input v-model="queryParams.myjrName" placeholder="请输入标题" class="input-with-select">
                                    <template #append>
                                        <el-button @click="pageList(null)" type="primary" icon="el-icon-search" style="background-color: #ff7f2e;color: #fff"/>
                                    </template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-scrollbar class="myjr-list-container">
                        <div class="my-item-container" v-for="item in dataList" :key="item.myjrId">
                            <div class="my-item-icon" title="播放" >
                                <svg v-if="item.myjrId !== this.musicId" @click="playMusic(item)" t="1770802334835" style="margin-top: 3px;margin-left: 3px"  class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5413" width="24" height="24"><path d="M512 97C282.8 97 97 282.8 97 512s185.8 415 415 415 415-185.8 415-415S741.2 97 512 97z m-1 759c-190.5 0-345-154.5-345-345s154.5-345 345-345 345 154.5 345 345-154.5 345-345 345z" p-id="5414" fill="#ff7f2e"></path><path d="M442.1 408.2L621.9 512 442.1 615.8V408.2m-59.9-113.9c-5.2 0-10 4.2-10 10v415.4c0 5.8 4.8 10 10 10 1.7 0 3.4-0.4 5-1.4l359.7-207.7c6.7-3.8 6.7-13.5 0-17.3L387.1 295.7c-1.6-1-3.3-1.4-4.9-1.4z" p-id="5415" fill="#ff7f2e"></path></svg>
                                <svg v-if="item.myjrId === this.musicId" @click="stopMusic()" t="1770859712561" style="margin-top: 3px;margin-left: 3px" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5389" width="24" height="24"><path d="M544 128v768h-64V128h64z m-192 128v512H288V256h64z m384 0v512h-64V256h64zM160 384v256H96v-256h64z m768 0v256h-64v-256h64z" fill="#ff7f2e" p-id="5390"></path></svg>
                            </div>
                            <div class="my-item-name">{{item.myjrName}}</div>
                            <div class="my-item-time">{{ timestampToTime(item.createTime) }}</div>
                        </div>
                        <data-empty v-if="dataList&&dataList.length===0" title="暂无数据"/>
                    </el-scrollbar>
                    <div class="page-container" v-if="dataList&&dataList.length>0">
                        <pageTag :background="true"
                                 :pageSizes="[10, 20, 30]"
                                 v-show="total > 0"
                                 :total="total"
                                 v-model:page.sync="queryParams.pageNum"
                                 v-model:limit.sync="queryParams.pageSize"
                                 @pagination="pageList" />
                    </div>

                </div>
                <div class="info-r-container" v-if="activeItem===2">
                    <div class="head-container">
                        <div class="left-head-container" @click="backList">
                            <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                        </div>
                        <div class="right-head-container">{{ this.classTitle }}</div>
                        <div class="left-head-container">
                        </div>
                    </div>
                    <data-empty :title="'暂无美术'"/>
                </div>
                <div class="info-r-container" v-if="activeItem===3">
                    <div class="head-container">
                        <div class="left-head-container" @click="backList">
                            <svg t="1766639305795" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="12595" width="28" height="28"><path d="M512 512m-465.454545 0a465.454545 465.454545 0 1 0 930.90909 0 465.454545 465.454545 0 1 0-930.90909 0Z" fill="#e6e6e6" p-id="12596"></path><path d="M512 1024C229.236364 1024 0 794.763636 0 512S229.236364 0 512 0s512 229.236364 512 512-229.236364 512-512 512zM443.904 515.258182l205.637818-205.637818a58.181818 58.181818 0 1 0-82.292363-82.292364l-246.830546 246.830545a58.181818 58.181818 0 0 0 2.606546 84.712728l244.31709 244.363636a58.181818 58.181818 0 1 0 82.292364-82.292364l-205.730909-205.730909z" fill="#ff7f2e" p-id="12597" data-spm-anchor-id="a313x.search_index.0.i5.3a373a81dKtAXk" class="selected"></path></svg>
                        </div>
                        <div class="right-head-container">{{ this.classTitle }}</div>
                        <div class="left-head-container">
                        </div>
                    </div>
                    <data-empty :title="'暂无主题班会'"/>
                </div>
            </div>
        </div>


        <div class="music-play-container" v-if="isPlayMusic">
            <audio id="musicPlay" controls controlslist="nodownload noplaybackrate" autoplay ref="audio">
                <source type="audio/mp3" :src="this.musicUrl" />
            </audio>
        </div>
    </div>
</template>
<script>
import dataEmpty from "@/components/dataEmpty.vue";
import pageTag from "@/components/Pagination/page.vue";
import {timestampDate, timestampToTime} from "@/utils/date";
import {infoMyjr, pageMyjr} from "@/api/admin/myjr";
import {queryDict} from "@/api/admin/public";

export default {
    name:'myjrPage',
    components:{pageTag, dataEmpty},
    props:{
        markInfo:{
            type: String,
            default:null
        },
        itemId:{
            type: String,
            default:null
        },
        itemName:{
            type: String,
            default:null
        },
    },
    watch:{
        markInfo(newValue,oldValue){
            this.showMode = 'pageSub';
        },
        itemId(newValue,oldValue){
            this.classItemId = newValue;
            this.pageList();
        },
        itemName(newValue,oldValue){
            this.classTitle = newValue;
        },
    },
    mounted() {
        this.pageList()
        this.getQueryDict();
    },
    data() {
        return {
            isPlayMusic:false,
            musicId:'',
            musicUrl:'',
            musicName:'',
            activeItem:1,//1-音乐，2-美术 3-主题班会
            classItemId:'',
            classTitle:'',
            showMode:'pageSub',
            timestampDate,
            queryParams: {
                myjrName:'',
                periodKey:'',
                gradeKey:'',
                myjrType:'',
                myjrItem:'',
                myjrGrade:'',
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            pageCount:0,
            dataList: [],
            periodList:[],
            gradeList:[],
            myjrGradeList:[],
            myjrId:'',
            form:{},  //数据
            timestampToTime,
        }
    },
    methods: {
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.gradeList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.pageList(null)
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'myjr_grade_period' }).then(res => {
                this.myjrGradeList = res.data.data;
            })
        },
        pageList(){
            this.dataList = []
            this.queryParams.myjrItem = this.classItemId;
            this.queryParams.myjrType = this.activeItem;
            pageMyjr(this.queryParams).then(res => {
                if (res.data.code === 1) {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                }else {
                    this.$message.error("请求出错")
                }
            })
        },
        backList(){
            this.stopMusic()
            this.showMode = "page"
            this.$emit('change-mode',this.showMode);
        },
        getMyjrInfo(){
            infoMyjr({ myjrId: this.myjrId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                }else {
                    this.$message.error("操作失败")
                }
            })
        },
        changeActiveItem(val){
            this.activeItem = val;
        },
        playMusic(item){
            this.musicId = item.myjrId
            this.musicUrl = item.myjrUrl
            this.musicName = item.myjrName
            this.isPlayMusic = true
            const audio = document.getElementById('musicPlay');
            audio.pause(); // 暂停当前播放，避免状态混乱
            audio.src = this.musicUrl; // 修改音频源
            audio.load(); // 关键：强制浏览器重新加载新的音频资源
            audio.play().catch(e => {
                console.warn('自动播放被阻止，可能需要用户手势触发:', e);
            });
        },
        stopMusic(){
            this.musicId = ''
            this.musicUrl = ''
            this.musicName = ''
            const audio = document.getElementById('musicPlay');
            if (audio){
                audio.pause(); // 暂停当前播放，避免状态混乱
                this.isPlayMusic = false;
            }

        }
    }
}
</script>
<style>
.myjr-studio_nav_content{
    width: 100%;
    height: auto;
}
.page-mode{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
}
.my-info-container{
    width: 100%;
    height: calc(100vh - 90px);
    display: flex;
}
.info-l-container{
    width: 160px;
    height: 100%;
    border-right: 1px solid #dcdfe6;
}
.class-item{
    width: 120px;
    height: 40px;
    background-color: #faf5ff;
    border-radius: 5px;
    color: #ff7f2e;
    line-height: 40px;
    margin-left: 20px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
}
.class-item-active{
    width: 120px;
    height: 40px;
    background-color: #ff7f2e;
    border-radius: 5px;
    color: #fff;
    line-height: 40px;
    margin-left: 20px;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
}
.info-r-container{
    width: calc(100% - 170px);
    height: 100%;
    margin-left: 10px;
}
.my-item-container{
    width: 98%;
    height: 30px;
    display: flex;
    border: .5px solid #dcdfe6;
    margin-top: 5px;
    border-radius: 2px;
}
.my-item-icon{
    width: 30px;
    height: 30px;
    cursor: pointer;
}
.my-item-name{
    width: calc(100% - 230px);
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    font-family: sans-serif;
}
.my-item-time{
    width: 200px;
    height: 30px;
    text-align: right;
    padding-right: 10px;
    box-sizing: border-box;
    line-height: 30px;
    font-size: 15px;
    color: #999999;
    font-family: sans-serif;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
}
.myjr-list-container{
    width: 100%;
    height: calc(100% - 140px)!important;
    padding: 10px;
    box-sizing: border-box;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 18px;
    color: #ff7f2e;
    line-height: 44px;
    font-weight: bold;
}
.page-container{
    display: grid;
    place-items: center;
    width: 98%;
    height: 40px;
    padding-top: 15px;
    box-sizing: border-box;
}
.music-play-container{
    position: absolute;
    bottom: 0; /* 底部对齐 */
    left: 0;
    z-index: 9999;
}
</style>